import _extends from "@babel/runtime/helpers/esm/extends";

var _actions;

// Action Types
import { actionTypes } from '../action-types';
var actions = (_actions = {}, _actions[actionTypes.AUTH_SET_USER] = function (state, _ref) {
  var user = _ref.payload.user;
  return _extends({}, state, {
    user: user
  });
}, _actions);
export var authReducer = function authReducer(state, action) {
  if (state === void 0) {
    state = {};
  }

  return actions[action.type] ? actions[action.type](state, action) : state;
};